import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: false,
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
  toastService = inject(ToastService);

  onUndo(): void {
    this.toastService.undo();
  }

  onDismiss(): void {
    this.toastService.dismiss();
  }
}
